import "./icon.css"
import type { IconName } from './IconName';

interface IconProps {
    className?: string;
    name: IconName;
    size?: "small" | "medium" | "large";
    spin?: boolean;
}



export const Icon = ({className, name, size="medium", spin = false, ...props}: IconProps) => {
    return <svg className={`icon icon-${size} ${className ? className : ""}`}  {...props}>
        <use href={`/icons/sprite.svg#${name}`} xlinkHref={`/icons/sprite.svg#${name}`}></use>
    </svg>
}